import { Component, DestroyRef, inject } from '@angular/core';
import { UserGridFooterService } from '@app/shared/components/user-grid/user-grid-footer.service';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'user-grid-footer',
    template: `
      <div>
        {{ 'LABEL.USERS' | translate }}
        <span [ngClass]="{'valid' : valid, 'invalid': !valid }">({{ user.selectionCount }} / {{ user.totalCount }}
          )</span>
      </div>
    `,
    styles: [`
    div {
      font-weight: bold;
    }
  `],
    standalone: false
})
export class UserGridFooterComponent implements ICellRendererAngularComp {
  private readonly userService = inject(UserGridFooterService);
  public user: any;

  private readonly destroyRef = inject(DestroyRef);

  /**
   * Get the validity of the number of selected users
   */
  public get valid(): boolean {
    return this.user.selectionCount <= this.user.totalCount;
  }

  /**
   * Method used by Ag-grid to initialise the cell with grid parameters
   * @param params
   */
  public agInit(params: ICellRendererParams): void {
    // Passed by the pinned row data
    this.user = params.data['userFooterCell'];

    // Listens to changes in selection and shows the result
    this.userService.footerSubject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((footer) => {
      this.user.selectionCount = footer;
    });
  }

  /**
   * Method used by Ag-Grid to tell the grid to refresh this cell
   * This component does not include refresh logic
   * @param _ Unused.
   * @returns {boolean}
   */
  public refresh(_: any): boolean {
    return false;
  }
}
